import React from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import RichTextPanel from "@clarion/foundation/dist/Helpers/components/RichTextPanel";
const ConfirmationStep = ({
  fields
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "account__header",
    field: fields.ConfirmationStepTitle
  }), /*#__PURE__*/React.createElement(RichTextPanel, {
    className: "account__description",
    text: fields.ConfirmationStepDescription
  }));
};
export default ConfirmationStep;